

import {Component, Mixins, Prop} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";

@Component({
  components: {}
})
export default class GonderilecekDilekcePicker extends Mixins(SimpleInputMixin) {
  @Prop() hideDetails!: boolean | string;
  @Prop() rules!: string;
  @Prop() dense!: string | boolean;

  get isHideDetails() {
    return this.hideDetails || this.hideDetails === "";
  }

  get isDense() {
    return this.dense || this.dense === "";
  }

  getSablon(text: any): string {
    let defaultHtml = "<p style='box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;'><span style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;'><strong style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;'>{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style='box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;'><span style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;'><strong style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;'>DOSYA NO:{dosyaEsasNo}</strong></span></p><p style='box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;'><span style='color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;'>{{icerik}}</span><b style='font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;'>{tarih}</b></p><p style='box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;'><span style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;'><strong style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;'>Alacaklı Vekili</strong></span></p><p></p><p style='box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;'><span style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;'><strong style='box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;'>Av.&nbsp;{avAdSoyad}</strong></span></p>"
    let sablon: string = defaultHtml.replace("{{icerik}}", text);
    return sablon;
  }

  hazirSablonlar = [
    {
      code: "tokiAlacaklıHaciz",
      title: "Alacak Haczi Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Dosya borçlusu\ların hakkında takip kesinleşmiş olup; dosyanın güncel kapak hesabı yapılarak borçluların doğmuş ve doğacak tüm hak ve alacaklarına haciz konulması için  TOPLU KONUT İDARESİ BAŞKANLIĞI’na (TOKİ) haciz müzekkeresi yazılmasını talep ederim dedi.</p><p>E-İmzalı beyanı okundu, çıkartıldı, dosyasına takıldı.</p>")
    },
    {
      code: "aleyhevelehedosyalardavekilliktencekilmetalebi",
      title: "Aleyhe ve Lehe Dosyalarda Vekillikten Çekilme Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula: [],
      html: this.getSablon("<p>Yukarıda numarası belirtilen  dosyada vekil olarak görev yapmaktayız. Gördüğümüz lüzum üzerine işbu dosyadaki vekillik görevimden istifa ediyorum.</p><p>İstifa ettiğime dair beyanlarımın borçlu/alacaklı  şirkete gönderilmesini ve yine bu beyanların gönderilmesi  konusunda dosyaya UYAP üzerinden  avans yatırıldığını ve UYAP da bulunan vekil kaydımın  silinmesini talep ederim.</p>")
    },
    {
      code: "arachaciz",
      title: "Araç Haczi Talebi ",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        borcluAdSoyad: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("Borçlu {borcluAdSoyad} adına varsa kayıtlı araçların tespiti ile kayden haczini talep ederim. "),
      multipleHtml: this.getSablon("Borçlular {borcluAdSoyad} adlarına varsa kayıtlı araçların tespiti ile kayden haczini talep ederim. ")
    },
    {
      code: "aracVeTapuKaydinaHacizKonmasiTalebiSorguSonuclu",
      title: "Araç ve Tapu Kaydına Haciz Konması Talebi - Sorgu Sonuçlu",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula: [],
      html: this.getSablon("<p>Müdürlüğünüze ait yukarıda numarası yazılı dosya borçlusunun adına kayıtlı araç ve tapu kaydına haciz konulmasını talep ederim.</p><p>Adına kayıtlı herhangi bir araç ve tapu kaydına rastlanmamıştır.</p>")
    },
    {
      code: "bankaHesapSorguTalebi",
      title: "Banka Hesap Sorgu Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda numarası yazılı dosyamız borçluları adına kayıtlı banka hesaplarının sorgulanarak, sorgu sonuçlarının dosyaya kaydının yapılmasını talep ederim.</p>")
    },
    {
      code: "besHacizTalebiTalebi",
      title: "BES Haciz Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Borçluların bireysel emeklilik sistemi katılımcısı olup olmadığının sorularak katılımcıise  katılım  bakiyesinin  borç  kadarınca  haczi  konulması  için  aşağıdaki  kuruma  müzekkere yazılmasını talep ederim.</p>")
    },
    {
      code: "hacizkonulmasitalebi",
      title: "Borçlunun Alacaklı Olduğu Dosyalardaki Alacaklar Üzerine Haciz Konulması Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Borçlunun alacaklı olduğu icra dosyalarındaki alacakları üzerine UYAP sistemi üzerinden haciz konulmasını, borçlunun taraf olduğu mahkeme dosyalarındaki tüm alacaklarına (harç,teminat, gider avansı) UYAP sistemi üzerinden haciz konulmasını,  talep ederim.</p>")
    },
    {
      code: "borclununVukuatliNufusKaydininCikartilmasiTalebi",
      title: "Borçlunun Vukuatlı Nüfus Kaydının Çıkartılması Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası sunulu dosya borçlusunun vukuatlı nüfus kaydının çıkartılmasını vefat etmiş babası veya annesi olması halinde UYAP’a taraf olarak eklenerek mal varlıklarının sorgulanmasını intikal edecek malları üzerine haciz konulmasını talep ederim.</p>")
    },
    {
      code: "borcmuhtirasigonderilmesitalebi",
      title: "Borç Muhtırası Gönderilmesi Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası yazılı olan dosyamız borçlusu adına, güncel kapak hesabı yapılarak, Bakiye Borç Muhtırası ve ekinde Kapak Hesabı gönderilmesini vekaleten talep ederiz.</p>")
    },
    {
      code: "kapanmatalep",
      title: "Dosya Kapanma Talebi - Harçsız",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası yazılı bulunan dosyanın borcu haricen tahsil edilmiş olup tahsil harcı borçlu tarafından dosyaya ödenecektir. Dosyanın kapatılması, işlemden kaldırılması ve varsa dosyadaki paranın geldiği yere iadesi ile dosyadaki tüm hacizlerin fekkini talep ederim. </p>")
    },
    {
      code: "kapanmatalep2",
      title: "Dosya Kapanma Talebi - Harçlı",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası yazılı bulunan dosya borcu haricen tahsil edildiğinden tahsil harcının tamamı ödenmiştir. Dosyanın kapatılması, işlemden kaldırılması ve varsa dosyadaki paranın geldiği yere iadesi ile dosyadaki tüm hacizlerin fekkini talep ederim. </p>")
    },
    {
      code: "kesinlesmetalep",
      title: "Dosya Kesinleşme Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası yazılı derdest dosyada borçluya ait sorgulama ekranına tıkladığımızda '' Borçlu için icra takibi kesinleşmediği için sorgulama yapamazsınız.'' ibaresi nedeni ile işlem yapamamaktayız.</p><p>Bu nedenle UYAP sistemine tebligat bilgilerinin girilerek takibin KESİNLEŞME işleminin İVEDİ olarak yapılmasını müdürlüğünüzden saygı ile arz ve talep ederim.</p>")
    },
    {
      code: "yenilemetalep",
      title: "Dosya Yenileme Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p>Yukarıda bilgileri yazılı icra dosyamız sehven düşürülmüş olup bu defa dosyanın harçsız olarak yenilenmesine karar verilmesini vekaleten arz ve talep ederiz.</p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Tarih : {tarih}</strong></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>"
    },
    {
      code: "yenilemetalep2",
      title: "Dosya Yenileme Talebi - 2",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p>Yukarıda bilgileri yazılı icra dosyamız takipsizlikten düşmüştür. Takipsizlikten düşmüş olan dosyamızın yenilenmesine karar verilmesini vekaleten arz ve talep ederiz.</p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Tarih : {tarih}</strong></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>"
    },
    {
      code: "gayrimenkul",
      title: "Gayrimenkul Haciz Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("Borçlunun adına kayıtlı gayrımenkullerin tespiti ile gayrımenkullerinin bulunması halinde haczi için ilgili Tapu Sicil Müdürlüğüne haciz müzekkeresi yazılmasını talep ederim.")
    },
    {
      code: "gayrimenkul2",
      title: "Gayrimenkul Haciz Talebi - 2",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("Borçlunun adına kayıtlı gayrımenkullerin tespiti ile gayrımenkullerinin bulunması halinde kaydına haciz konulmasını ve takyidat bilgisinin uyap sistemine eklenmesini talep ederim.")
    },
    {
      code: "menkulfiilihacizvemuhafazatalebi",
      title: "Menkul Fiili Haciz ve Muhafaza Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("Borçlunun taşınır mallarının haczi için adresinde haciz yapılması, kapalı yerlerin çilingir ile açılması, haczedilen malların muhafaza altına alınmasını talep ederim. ")
    },
    {
      code: "mukerreryatirilantutariniadesitalebi",
      title: "Mükerrer Yatırılan Tutarın İadesi Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula: [],
      html: this.getSablon("Yukarıdaki esas sayılı dosyada, takip açılışında mükerrer yatırılan ödeme emri tebliğ masrafının, ahzu kabz yetkimiz olmadığından alacaklı müvekkil kurum IBAN hesabına iadesini talep ederim. ")
    },
    {
      code: "geneltalepozel",
      title: "Genel Sorgu ve Haciz Talebi (Özel)",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        isyeriUnvani: "",
        borcluAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      options: {
        list: true,
        separator: "",
        lastText: " talep ederim."
      },
      specialFields: [
        {
          content: "Adına kayıtlı taşınmazlarının sorgulanmasını, var ise haczi için ilgili Tapu Müdürlüğü’ne sistem üzerinden müzekkere yazılmasını,",
          sorgula: []
        },
        {
          content: "Adına kayıtlı gayrimenkullerin tespiti ile gayrimenkullerinin bulunması halinde haczi için ilgili Tapu Sicil Müdürlüğüne haciz müzekkeresi yazılmasını,",
          sorgula: []
        },
        {
          content: "Adına kayıtlı gayrimenkullerin tespiti ile gayrimenkullerinin bulunması halinde kaydına haciz konulmasını ve takyidat bilgisinin UYAP sistemine eklenmesini,",
          sorgula: []
        },
        {
          content: "Adına kayıtlı araçların sorgulanmasını, var ise kaydına haciz konularak takyidatlarının sisteme kaydedilmesini,",
          sorgula: []
        },
        {
          content: "Adına varsa kayıtlı araçların tespiti ile kayden haczini,",
          sorgula: []
        },
        {
          content: "Posta çeki hesabının sorgulanmasını, hesabı var ise haciz konulması için PTT Genel Müdürlüğü’ne müzekkere yazılmasını,",
          sorgula: []
        },
        {
          content: "SGK sorgularının yapılmasını, var ise ilgili kuruma maaş haciz müzekkeresi gönderilmesini,",
          sorgula: []
        },
        {
          content: "Borçlu {borcluAdSoyad}’nin T. Vakıflar Bankası A.Ş.’nin tüm şubelerindeki doğmuş ve doğacak tüm hak ve alacakları ile vadeli, vadesiz, döviz vs. tüm hesaplarına haciz konulması için T. Vakıflar Bankası A.Ş.’ye birinci haciz ihbarnamesi gönderilmesini,",
          sorgula: []
        },
        {
          content: "Borçlu {borcluAdSoyad}, ekte sunulu UYAP dökümünden de anlaşılacağı üzere, halen {isyeriUnvani}’de çalışmaktadır. Borçlu bu zamana dek alacaklı müvekkile borcunu ödemediğinden maaşına ve elde etmekte olduğu ikramiye, nema, vergi iadesi, tazminat, fon, döner sermaye, yakacak yardımı, sosyal yardım, işten ayrılması halinde kıdem, ihbar tazminatı gibi diğer gelirleri üzerine haciz koyularak haczedilen paranın Müdürlüğünüz hesabına yatırılması için ilgili şirkete müzekkere yazılmasını,",
          sorgula: ["sgk"]
        },
        {
          content: "Borcu bitinceye kadar almakta olduğu ücret, maaş ve İş Yasası uyarınca ücretten sayılan ikramiye, prim, nema gibi sair alacaklarının 1/4 ' ünün ve yakacak yardımı, sosyal yardım, işten ayrılması halinde kıdem ve ihbar tazminatı ile diğer tüm işçilik alacakları, tazminat ve teminatlarının tamamının borç miktarı kadarına haciz konulması ve haczedilen paranın Müdürlüğünüz hesabına yatırılması için çalışmakta olduğu {isyeriUnvani}  müzekkere gönderilmesini,",
          sorgula: ["sgk"]
        },
        {
          content: "Henüz ödenmeyen iş bu borcundan dolayı, MERNİS adresi ve gösterilecek diğer adreslerindeki haczedilmezlik kapsamında olmayan menkul, gayrimenkul malları ile 3. kişilerdeki hak ve alacaklarının, adına kayıtlı araçların görülmesi halinde hacziyle muhafazasına, haciz mahallinde rastlanması halinde özel kasalarının açtırılarak nakit ve nakit değeri taşıyan kıymetli evraklarının hacziyle muhafazasına, gerektiğinde çilingir ve güvenlik kuvveti çağrılmasına, borçlunun yokluğunda haciz yapılması halinde 103 yerine geçmek üzere hazıra ihtarat yapılmasını,",
          sorgula: []
        },
        {
          content: "Gelir İdaresi Başkanlığı (GİB) sorgusunun yapılmasını,",
          sorgula: []
        },
        {
          content: "Adına kayıtlı posta çeki hesabının sorgulanmasını,",
          sorgula: []
        },
        {
          content: "Adına kayıtlı araçların UYAP sisteminden sorgulanmasını,",
          sorgula: []
        },
        {
          content: "Adına kayıtlı gayrimenkul, posta çeki hesabı ve GİB’in UYAP’ tan sorgulanmasını, ",
          sorgula: []
        },
        {
          content: "{borcluAdSoyad}'a miras yoluyla intikal edecek malların tespit edilebilmesi için UYAP sisteminden aile kayıt örneğinin sorgulanmasını,",
          sorgula: []
        },
        {
          content: "Adına kayıtlı taşınmazların sorgulanmasını,",
          sorgula: []
        },
        {
          content: "GSM kayıt bilgilerinin sorgulanmasını,",
          sorgula: []
        },
        {
          content: "Borçlu/lar adına kayıtlı iken başkalarına satılan veya bağışlanan ya da devredilen taşınmaz/lar (Pasif Kayıtlar Yönünden) UYAP-TAKBİS sisteminden sorgulama yapılmasını,",
          sorgula: []
        },
        {
          content: "Dosya borçlularının alacaklı sıfatı ile yer aldığı icra dosyalarının tespit edilmesi halinde listesinin yüklenmesini ve UYAP sistemi üzerinden haciz müzekkeresi gönderilmesini,",
          sorgula: []
        },
        {
          content: "Borçlunun UYAP sorgusunda adına kayıtlı taşınmaz kaydı vardır. Aktif  haczi için UYAP üzerinden sorgulanmasına, taşınmaz tapu kaydına haciz şerhi işlenmesi ve Tapu kaydındaki takyidatların sorulması için  haciz müzekkeresinin yazılmasını,",
          sorgula: []
        },
        {
          content: "Borçlunun UYAP sorgusunda adına kayıtlı araç/lar kaydı vardır. Araç/lar üzerine UYAP üstünden haczin işlenmesine, takyidat çıktısının bir örneğinin de dosyaya konmasına ve varsa başkaca araç/lar üzerine de haciz işlenmesine  (Motorbisiklet iki tekerlekli v.b. hariç) takyidat çıktısının bir örneğinin de dosyaya konmasına karar verilmesini,",
          sorgula: []
        },
        {
          content: "Borçlu adına kayıtlı araçların sorgulanmasını, varsa takyidatlarının sisteme kaydedilmesini,",
          sorgula: []
        },
        {
          content: "UYAP-SGK MOSIP haciz entegrasyonu sorgu sonucu gelen hak ve alacaklara haciz konulmasını,",
          sorgula: []
        },
        {
          content: "Borçlu/borçluların Nüfus Aile Kayıt Tablosunun sorgulanarak; borçlunun anne ile babasının ölü bulunması halinde UYAP kayıtlarına Muris olarak eklenmesini, borçluya intikal edecek gayrimenkullerin ve araçların tespitini, tespiti yapılan gayrimenkullerin ve araçların kayıtlarına haciz konulmasını,",
          sorgula: []
        },
        {
          content: "Borçluların banka hesaplarının sorgulanmasını, tespiti halinde İİK.89/1 haciz ihbarnamelerinin e-tebligat ile gönderilmesini,",
          sorgula: []
        }
      ],
      html: `<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p>
				<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p>
				<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">KONU:Genel sorgu ve haciz talebi</strong></span></p>
				<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">AÇIKLAMA:E-imzalıdır.</strong></span></p>
				<p> Yukarıda esas numarası yazılı dosyanın borçlusu/borçlularının;</p>
				{dilekceOzelAlanlar}
				<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Tarih : {tarih}</strong></span></p>
				<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p>
				<p></p>
				<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>`,
    },
    {
      code: "geneltalep",
      title: "Genel Sorgu ve Haciz Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">KONU:Genel sorgu ve haciz talebi</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">AÇIKLAMA:E-imzalıdır.</strong></span></p><p>       Yukarıda esas numarası yazılı dosyanın borçlusu/borçlularının;</p><p>1- Adına kayıtlı taşınmazlarının sorgulanmasını, var ise ilgili Tapu Müdürlüğü’ne sistem üzerinden müzekkere yazılmasını,</p><p>2- Adına kayıtlı araçların sorgulanmasını, var ise kaydına haciz konularak takyidatlaeının sisteme kaydedilmesini,</p><p>3- Gelir İdaresi Başkanlığı (GİB) sorgusunun yapılmasını,</p><p>4- Posta çeki hesabının sorgulanmasını, hesabı var ise haciz konulması için PTT Genel Müdürlüğü’ne müzekkere yazılmasını,</p><p>5- SGK sorgularının yapılmasını, var ise ilgili kuruma maaş haciz müzekkeresi gönderilmesini talep ederim.</p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Tarih : {tarih}</strong></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>"
    },
    {
      code: "geneltalep2",
      title: "Genel Sorgu ve Haciz Talebi - 2",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: `<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p>
                <p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p>
                <p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">KONU:Genel sorgu ve haciz talebi</strong></span></p>
                <p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">AÇIKLAMA:E-imzalıdır.</strong></span></p>
                <p> Yukarıda esas numarası yazılı dosyanın borçlusu/borçlularının;</p>
                <p>1- Adına kayıtlı taşınmazlarının sorgulanmasını, var ise ilgili Tapu Müdürlüğü’ne sistem üzerinden müzekkere yazılmasını,</p>
                <p>2- Adına kayıtlı araçların sorgulanmasını, var ise kaydına haciz konularak takyidatlaeının sisteme kaydedilmesini,</p>
                <p>3- Gelir İdaresi Başkanlığı (GİB) sorgusunun yapılmasını,</p>
                <p>4- Posta çeki hesabının sorgulanmasını, hesabı var ise haciz konulması için PTT Genel Müdürlüğü’ne müzekkere yazılmasını,</p>
                <p>5- Borcu bitinceye kadar almakta olduğu ücret, maaş ve İş Yasası uyarınca ücretten sayılan ikramiye, prim, nema gibi sair alacaklarının 1/4 ‘ ünün ve yakacak yardımı, sosyal yardım, işten ayrılması halinde kıdem ve ihbar tazminatı ile diğer tüm işçilik alacakları, tazminat ve teminatlarının tamamının borç miktarı kadarına haciz konulması ve haczedilen paranın Müdürlüğünüz hesabına yatırılması için çalışmakta olduğu işyerine müzekkere gönderilmesini,</p>
                <p>6- Henüz ödenmeyen iş bu borcundan dolayı, MERNİS adresi ve gösterilecek diğer adreslerindeki haczedilmezlik kapsamında olmayan menkul, gayrimenkul malları ile 3. kişilerdeki hak ve alacaklarının, adına kayıtlı araçların görülmesi halinde hacziyle muhafazasına, haciz mahallinde rastlanması halinde özel kasalarının açtırılarak nakit ve nakit değeri taşıyan kıymetli evraklarının hacziyle muhafazasına, gerektiğinde çilingir ve güvenlik kuvveti çağrılmasına, borçlunun yokluğunda haciz yapılması halinde 103 yerine geçmek üzere hazıra ihtarat yapılmasını talep ederim.</p>
                <p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Tarih : {tarih}</strong></p>
                <p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p>
                <p></p>
                <p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>`
    },
    {
      code: "hacizKaldirmaTalebi",
      title: "Haciz Kaldırma Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p>" +
          "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p>" +
          "<p>Yukarıdaki esas sayılı dosyada bulunan bütün hacizlerin kaldırılarak dosyanın işlemden kaldırılmasını talep ederim.<span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{tarih}</strong></span></p>" +
          "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">E-İMZALIDIR</strong></p>" +
          "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>"
    },
    {
      code: "intikalSorguTalebi",
      title: "İntikal Sorgu Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Daireniz dosyasında taraf olarak bulunan borçlunun/borçluların PASİF ÖLÜ KAYDI SORGUSUNUN YAPILARAK;</p><p>&nbsp; &nbsp; &nbsp; - Anne-babasının VEFAT EDİP ETMEDİĞİNİN SORGULANMASINI;</p><p>&nbsp; &nbsp; &nbsp; - Anne-babasının herhangi birinin vefat etmiş olması halinde vefat edenin gayrimenkul sahiplik sorgusunun yapılabilmesi için dosyaya muris sıfatıyla eklenmesine,</p><p>karar verilmesini saygılarımla talep ederim.</p>")
    },
    {
      code: "intikalSorguTalebi2",
      title: "İntikal Sorgu Talebi - 2",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Nüfus kayıt örneğinin sorgulanarak borçlu/ların anne ve babasının ölü olup olmadığı, ölmüş olması durumunda İİK. Madde 94. uyarınca borçluya intikal edecek olan ve borçlunun henüz tapuya tescil ettirmediği mülkiyet veya diğer ayni hakların sorgularının yapılarak sonuçlarının UYAP’a kaydedilmesini ve haciz tesis edilmesine karar verilmesini talep ederim.</p>")
    },
    {
      code: "kesinlestirmeIslemiVeHacizTalepleri",
      title: "Kesinleştirme İşlemi ve Haciz Talepleri",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon
      (
          "<p>Talep : Yukarıda esas numarası yazılı dosyada borçlu/lar adına  dosyanın kesinleştirme işlemi yapılarak,</p>" +
          "<p>- EGM sorgusu yapılarak borçlu/lar adına kayıtlı araç/lar çıkması halinde  araç/lar üzerine haciz konulması ve araç takyidatlarının çıkartılması,</p>" +
          "<p>- Borçlu/lar adına ayrı ayrı SGK sorgusu yapılması  ve  SGK kaydı çıkması halinde borçlu/ların  almakta olduğu ücretinin nema, toplu  sözleşme  farkı ve  ikramiyelerinin 1/4\"ünün; teminatlar bakımından borçlunun iş akdinin feshi halinde ihbar ve kıdem tazminatının tamamının ; emekli olması halinde ödenecek emekli ikramiyesinin tamamının borç miktarına yetecek kadarına haciz konulmasına; borçlunun maaş miktarında veya iş akdinin sona ermesi durumunda veya maaşının başka bir iş yerinden alınmasını zorunlu kılacak bir değişiklik olmasında gereken bilgilerin müdürlüğünüz dosyasının sırasının bildirilmesinin de istenmesine karar verilmesini ,karar gereğini yerine getirmek üzere ilgili iş yerine müzekkere yazılması,</p>" +
          "<p>- Borçlunun kamu iştirakçısı olması halinde UYAP üzerinden emekli ikramiyesine haciz konulması ve dosyaya eklenmesi,</p>" +
          "<p>- Takbis sorgulamasının yapılmasını, borçlu/lar adına tapu kaydı çıkması halinde Tapu Sicil Müdürlügüne haciz müzekkeresi yazılarak borçlunun taşınmazlarına haciz konulması ve tapu takyidatlarının istenilmesi için müzekkere yazılması,</p>" +
          "<p>- Posta çeki hesabı çıkması halinde ilgili P.T.T müdürlüğüne haciz müzekkeresi  yazılması,</p>" +
          "<p>- Borçlu adına alacaklı olduğu icra dosyası sorgulanarak, dosyanın güncel kapak hesabı üzerinden bu dosyamızdan borçlunun alacaklı olduğu dosyaya haciz konulması,</p>" +
          "<p>- Borçlu/lara ait  GSM sorgusun yapılması ve sisteme kaydedilmesi talep olunur.</p>"
      )
    },
    {
      code: "maashaczi",
      title: "Maaş Haczi Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        isyeriUnvani: "",
        borcluAdSoyad: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula:["sgk"],
      html: this.getSablon("Borçlu {borcluAdSoyad}, ekte sunulu UYAP dökümünden de anlaşılacağı üzere, halen {isyeriUnvani}’de çalışmaktadır. Borçlu bu zamana dek alacaklı müvekkile borcunu ödemediğinden maaşına ve elde etmekte olduğu ikramiye, nema, vergi iadesi, tazminat, fon, döner sermaye, yakacak yardımı, sosyal yardım, işten ayrılması halinde kıdem, ihbar tazminatı gibi diğer gelirleri üzerine haciz koyularak haczedilen paranın Müdürlüğünüz hesabına yatırılması için ilgili şirkete müzekkere yazılmasını talep ederim."),
      multipleHtml: this.getSablon("Borçlular {borcluAdSoyad}, ekte sunulu UYAP dökümünden de anlaşılacağı üzere, halen {isyeriUnvani}’de çalışmaktadır. Borçlular bu zamana dek alacaklı müvekkile borcunu ödemediğinden maaşına ve elde etmekte olduğu ikramiye, nema, vergi iadesi, tazminat, fon, döner sermaye, yakacak yardımı, sosyal yardım, işten ayrılması halinde kıdem, ihbar tazminatı gibi diğer gelirleri üzerine haciz koyularak haczedilen paranın Müdürlüğünüz hesabına yatırılması için ilgili şirkete müzekkere yazılmasını talep ederim.")
    },
    {
      code: "malBeyanindaBulunulmasiIcinMuhtiraTalebi",
      title: "Mal Beyanında Bulunulması İçin Muhtıra Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası sunulu dosya borçlusu Belediye Başkanlığı'na yasal süre içinde dosya borcunu On (10) gün içerisinde ödemesi veya mal beyanında bulunması için muhtıra\n" +
          "gönderilmesini,\n" +
          "On (10) gün içinde mal bildirilmemesi, bildirilen malvarlığının\n" +
          "alacağı karşıladığına dair şüpheye yer vermeksizin bilgi ve belgelerin\n" +
          "sunulmaması ya da eksik bildirilmesi halinde diğer mallar hakkında da\n" +
          "haciz işlemlerine devam edileceğinin bildirilmesini vekil eden adına arz ve\n" +
          "talep ederim.</p>")
    },
    {
      code: "malvarligiSorgulamaTalebi",
      title: "Malvarlığı Sorgulama Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Müdürlüğünüz nezdinde işlem gören yukarıda numarası belirtilen dosya borçlusu/borçlularının adına kayıtlı şirketlerin tespiti için Türkiye Odalar ve Borsalar Birliği (TOBB) ve İstanbul Vergi Dairesi Başkanlığına müzekkere yazılmasını talep ederim.</p>")
    },
    {
      code: "mernisAdresineOdemeIcraEmri",
      title: "Mernis Adresine Ödeme Emri/ İcra Emri Çıkartılması Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Müdürlüğünüz nezdinde işlem gören yukarıda numarası belirtilen dosya borçlusu/borçlularının sistemden sorgulanacak MERNİS/MERSİS ADRESİNE ödeme emri/icra emri tebliğini talep ederim.</p>")
    },
    {
      code: "icraOdemeEmrininTebligi",
      title: "İcra/Ödeme Emrinin Hazırlanarak Tebliğ Edilmesi Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Dosyanın tetkikinde İcra Ödeme emrinin henüz hazırlanmadığı görülmüş olup,İcra Ödeme emri ile Tebligatınhazırlanmasını ve Entegrasyon sorgusu sonucu gelen Mernis Adresine (Normal Tebligat) İcra/Ödeme Emrini PTT’ye verilmesini talep ederim.</p>")
    },
    {
      code: "mersisNumarasininUyapaTanimlanmasi",
      title: "MERSİS Numarasının UYAP'a Tanımlanması Talebi -Ziraat Bankası",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas sayılı dosyada kayıtlı olmaması halinde, alacaklı Ziraat Bankası A.Ş 'nin  Mersis numarası olan 0998006967505633’ün  UYAP sistemine tanımlanmasını talep ederim.</p>")
    },
    {
      code: "pasifTasinmazKaydininSorgulanmasiTalebi",
      title: "Pasif Taşınmaz Kaydının Sorgulanması Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Borçlunun pasif taşınmaz kaydı vasıtası ile İİK.'nın 277. vd. maddelerinde düzenlenen tasarrufun iptali davası açarak alacağımıza kavuşma imkanına sahip olunacağından ve bu yöndeki bir bilgiye ulaşamayacağımız hususları göz önüne alınarak yukarıda esas numarası sunulu dosyanın borçlusuna ait PASİF TAŞINMAZ KAYDININ SORGULANMASINI talep ederim.</p>")
    },
    {
      code: "postaceki",
      title: "Posta Çeki Sorgulaması Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\"> Borçlu adına kayıtlı posta çeki hesabının sorgulanmasını talep ederim.</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n",
      multipleHtml: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\"> Borçlular adına kayıtlı posta çeki hesabının sorgulanmasını talep ederim.</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n"
    },
    {
      code: "postacekihacizkonulmasitalebi",
      title: "Posta Çeki Hesabına Haciz Konulması Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıdaki esas numarası yazılı dosyanın borçlusu/borçlularının;</p><p>Sorgu sonucu gelen posta çeki hesabına haciz konulması için yazı yazılmasını talep ederim.</p><p>Borçlu Adı Soyadı ve TC Kimlik No'su: {borcluAdSoyad} </p>")
    },
    {
      code: "postacekihacizkonulmasitalebi2",
      title: "Posta Çeki Hesabına Haciz Konulması Talebi - 2",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("Yukarıda esas numarası sunulu dosyada borçluların posta çeki hesabına haciz konulmasını talep ederiz.")
    },
    {
      code: "takipTalebindekiAdreseOdemeEmriGonderilmesiTalebi",
      title: "Takip Talebindeki Adrese Ödeme Emri Gönderilmesi Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Müdürlüğünüz nezdinde işlem gören yukarıda numarası belirtilen dosya borçlusu/borçlularının takip talebinde belirtilen adresine ödeme emri/icra emri tebliğini talep ederim.</p>")
    },
    {
      code: "takyidatSorgulamaTalebiTasinmaz",
      title: "Takyidat Sorgulama Talebi, Taşınmaz",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Dosya borçlusu adına kayıtlı bulunan tüm taşınmazların takyidat bilgisinin sorgulanarak UYAP sistemine kaydedilmesini talep ederim.</p>")
    },
    {
      code: "taputrafikpostacekihaczitalep",
      title: "Tapu, Trafik, Posta Çeki Haczi Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Dosya borçlusunun UYAP üzerinden tapu, trafik ve PTT posta çeki hesap sorgusunun yapılarak tespit edilmesi halinde;</p><p>a) Gayrimenkulleri üzerine haciz konulmasına;</p><p>b) Araç plakları üzerine haciz konulmasına;</p><p>​c) Posta çeki hesapları var ise müzekkere yazılarak hesap üzerine haciz konulmasına;</p><p>karar verilmesini talep ederim.</p><p>Borçlu Adı Soyadı ve TC Kimlik No'su: {borcluAdSoyad} </p>")
    },
    {
      code: "tebligatinUyapSistemineTaranmasiTalebi",
      title: "Tebligatın UYAP Sistemine Taranması Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası yazılı derdest dosyaya ait tebligatın UYAP sistemine taranmasını ve dosyanın UYAP sisteminden kesinleştirilmesini talep ederim.</p>")
    },
    {
      code: "temlikNedeniyleIstifaTalebi",
      title: "Temlik Nedeniyle İstifa Talebi",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esas numarası belirtilen dosyanın müvekkilimizce temlik edilmesi nedeniyle istifa ediyoruz, UYAP kaydımızın kapatılmasını talep ederiz.</p>")
    },
    {
      code: "21egoretebligattalebi",
      title: "TK. md.21’e Göre Tebligat Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esası belirtilen dosyamız borçlusuna gönderilen ödeme emri bila tebliğ olarak dönmüş olup borçlunun UYAP sistemi üzerinden MERNİS adresinin tespiti ile tespit edilen adrese yeniden ödeme emri gönderilmesini, MERNİS adresi ile tebligat yapılamayan adresin aynı olmasından dolayı ödeme emrinin TK m.21/2 hükümlerine göre tebliğ edilmesini talep ederim. </p>")
    },
    {
      code: "35egoretebligattalebi",
      title: "TK. md.35’e Göre Tebligat Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Dosyamız borçlusu şirkete gönderilen ödeme emri BİLA dönmüştür. Ticaret Sicil Gazetesindeki adres ile bila dönen adres aynı olduğu anlaşılmakla, bu kez borçlu şirkete T.K. 35. md. gereğince ödeme emri gönderilmesini vekaleten talep ederiz.</p>")
    },
    {
      code: "turkcellmuzekere",
      title: "Turkcell'e Müzekkere Gönderilmesi Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Borçlu adına kayıtlı TURKCELL telefon numarasının olup/olmadığının, varsa iş ve ikametgah adresleri ile bildirilmesi için TURKCELL İLETİŞİM HİZMETLERİ A.Ş.'ye müzekkere yazılmasını talep ederim.</p><p>Borçlu Adı Soyadı ve TC Kimlik No'su: {borcluAdSoyad} </p>")
    },
    {
      code: "avukatinismisildirilmesi2",
      title: "UYAP’tan Avukatın İsminin Sildirilmesi Talebi 2",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        alacakliAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula: [],//dosyaTaraflari
      html: this.getSablon("<p>Borçlu aleyhine açılan işbu takip dosyasında, tarafımca  görülen lüzum üzerine alacaklı   {alacakliAdSoyad} ’nin vekilliğinden   çekilmekteyim. </p><p>Bu sebeple tarafımın UYAP kaydının silinmesini talep ederim.</p>")
    },
    {
      code: "vekileklemetalebi",
      title: "Vekil Ekleme Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Müdürlüğünüzün  yukarıda  esas numarası bildirilen dosyada müvekkil şirket vekaletnamesi dosyaya ibraz olunmuş, vekalet harcı ve baro/vekalet pulu bedeli icra dosyasına ödenmiş bulunduğundan alacaklı vekili sıfatı ile taraf olarak eklenmemiz talep olunur.</p>")
    },
    {
      code: "silinmetalep",
      title: "Vekillikten Çekilme Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Alacaklı vekili geldi.</p><p>Borçluya ait olan dosya varlık şirketine devredilmiş olup, vekil olarak tarafımın UYAP SİSTEMİNDEN silinmesini talep ederim dedi.</p>")
    },
    {
      code: "silinmetalep2",
      title: "Vekillikten Çekilme Talebi - 2",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Alacaklı ile aramızdaki iş akdi sona erdiği için vekillik görevim de sona ermiştir. Bu sebeple işten ayrıldığım için dosya ile ilgili vekil olarak tarafımın UYAP SİSTEMİNDEN silinmesini ve bundan sonra yapılacak tüm tebligatların alacaklı adresine yapılmasını talep ederim, dedi.</p>")
    },
    {
      code: "silinmetalep3",
      title: "Vekillikten Çekilme Talebi - 3",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda numarası belirtilen dosyada alacaklı vekili olarak görev yapmaktayım. Gördüğüm lüzum üzerine işbu dosyadaki vekillik görevimden çekiliyorum.Bu nedenle UYAP'ta bulunan vekillik kaydımın silinmesini talep ederim. </p>")
    },
    {
      code: "silinmetalep4",
      title: "Vekillikten Çekilme Talebi - 4",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda numarası belirtilen dosyada alacaklı vekili olarak görev yapmaktayım. Dosya başkaca vekil tarafından takip edildiğinden yeni vekil dosyaya yeni vekaletname sunulduğundan UYAP'ta bulunan vekillik kaydımın silinmesini talep ederim.</p>")
    },
    {
      code: "yenidenodemeemrigonderilmesi",
      title: "Yeniden Ödeme Emri Gönderilmesi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        borcluAdSoyad: "",
        borcluMernisAdresi: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula: ["mernis"],
      html: this.getSablon("<p>Borçlu/lar  {borcluAdSoyad}’ye gönderilen tebligat/lar bila iade olduğundan; Borçlu/ların  MERNİS adresi olan {borcluMernisAdresi} adresine yeniden ödeme emrinin gönderilmesine karar verilmesini talep ederim. </p>")
    },
    {
      code: "odemeemritalebi",
      title: "21/2 Ödeme Emri Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Yukarıda esası belirtilen dosyamız borçlusuna gönderilen ödeme emri bila tebliğ olarak dönmüş olup borçlunun UYAP sistemi üzerinden MERNİS adresinin tespiti ile tespit edilen adrese yeniden ödeme emri gönderilmesini, MERNİS adresi ile tebligat yapılamayan adresin aynı olmasından dolayı ödeme emrinin TK m.21/2 hükümlerine göre tebliğ edilmesini talep ederim.</p>")
    },
    {
      code: "feragattalep",
      title: "7420 s.lı K. Kapsamında Feragat Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: this.getSablon("<p>Dosyanın 7420 Sayılı Kanunun Geçici 2.Maddesi Kapsamında Feragat nedeniyle (İlgili kanunun uygulanmasına ilişkin usul ve esaslar hakkındaki tebliğ uyarınca tüm süreçlerin müdürlüğünüzce yerine getirilerek varsa hacizlerin de fekkini talep ederiz.) kapatılmasını talep ederim. </p>")
    },
    {
      code: "891",
      title: "89/1 Alacak haczi - Vakıflar Bankası",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\">Borçlu {borcluAdSoyad}’nin T. Vakıflar Bankası A.Ş.’nin tüm şubelerindeki doğmuş ve doğacak tüm hak ve alacakları ile vadeli, vadesiz, döviz vs. tüm hesaplarına haciz konulması için T. Vakıflar Bankası A.Ş.’ye birinci haciz ihbarnamesi gönderilmesini talep ederim&nbsp;</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n",
      multipleHtml: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\">Borçlular {borcluAdSoyad}’nin T. Vakıflar Bankası A.Ş.’nin tüm şubelerindeki doğmuş ve doğacak tüm hak ve alacakları ile vadeli, vadesiz, döviz vs. tüm hesaplarına haciz konulması için T. Vakıflar Bankası A.Ş.’ye birinci haciz ihbarnamesi gönderilmesini talep ederim&nbsp;</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n"
    },
    {
      code: "891.2",
      title: "89/1 Alacak haczi - Ziraat Bankası",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\">Borçlu {borcluAdSoyad}’nin Ziraat Bankası A.Ş.’nin tüm şubelerindeki doğmuş ve doğacak tüm hak ve alacakları ile vadeli, vadesiz, döviz vs. tüm hesaplarına haciz konulması için Ziraat Bankası A.Ş’ye birinci haciz ihbarnamesi gönderilmesini talep ederim&nbsp;</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n",
      multipleHtml: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\">Borçlular {borcluAdSoyad}’nin Ziraat Bankası A.Ş.’nin tüm şubelerindeki doğmuş ve doğacak tüm hak ve alacakları ile vadeli, vadesiz, döviz vs. tüm hesaplarına haciz konulması için Ziraat Bankası A.Ş’ye birinci haciz ihbarnamesi gönderilmesini talep ederim&nbsp;</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n"
    },
    {
      code: "891ozel",
      title: "89/1 Alacak haczi talebi (Özel)",
      contentXml: "",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        bankaAdi: "",
        borcluAdSoyad: "",
        tcKimlikNo: "",
        avAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      options: {
        list: false,
        separator: ",",
        lastText: ""
      },
      //{dilekceOzelAlanlar} koyulmali html icerisine
      html: "<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\">Borçlu {borcluAdSoyad}’nin {dilekceOzelAlanlar}’nin tüm şubelerindeki doğmuş ve doğacak tüm hak ve alacakları ile vadeli, vadesiz, döviz vs. tüm hesaplarına haciz konulması için {dilekceOzelAlanlar} ’ye birinci haciz ihbarnamesi gönderilmesini talep ederim&nbsp;</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n",
      //multipleHtml:"<p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 22px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: center;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">{icraDairesi} İCRA MÜDÜRLÜĞÜ’ NE</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">DOSYA NO:{dosyaEsasNo}</strong></span></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: justify;\"><span style=\"color: rgb(0, 0, 0); font-size: 14px; text-align: start; font-family: helvetica, arial, sans-serif;\">Borçlular {borcluAdSoyad}’nin {bankaAdi}’nin tüm şubelerindeki doğmuş ve doğacak tüm hak ve alacakları ile vadeli, vadesiz, döviz vs. tüm hesaplarına haciz konulması için Ziraat Bankası A.Ş’ye birinci haciz ihbarnamesi gönderilmesini talep ederim&nbsp;</span><b style=\"font-family: helvetica, arial, sans-serif; color: rgb(0, 0, 0); font-size: 14px;\">{tarih}</b></p><p style=\"text-aligin:left\"><b></b></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Alacaklı Vekili</strong></span></p><p></p><p style=\"box-sizing: inherit; border: 0px; margin-bottom: 15px; padding: 0px; font-size: 15px; color: rgb(34, 34, 34); overflow-wrap: break-word; line-height: 24px; font-family: Verdana, sans-serif; text-align: right;\"><span style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px; font-family: helvetica, arial, sans-serif;\"><strong style=\"box-sizing: inherit; border: 0px; margin: 0px; padding: 0px;\">Av.&nbsp;{avAdSoyad}</strong></span></p>\n",
      specialFields: [
        {
          content: "HSBC BANK A.Ş",
          sorgula: []
        },
        {
          content: "ICBC TURKEY BANK A.Ş.",
          sorgula: []
        },
        {
          content: "ING BANK A.Ş.",
          sorgula: []
        },
        {
          content: "İLLER BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "KUVEYT TÜRK KATILIM BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "ODEA BANK A.Ş.",
          sorgula: []
        },
        {
          content: "QNB FİNANS BANK A.Ş.",
          sorgula: []
        },
        {
          content: "ŞEKERBANK T.A.Ş.",
          sorgula: []
        },
        {
          content: "TURKİSH BANK A.Ş.",
          sorgula: []
        },
        {
          content: "TURKLAND BANK A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRK EKONOMİ BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRK EXİMBANK",
          sorgula: []
        },
        {
          content: "TÜRKİYE CUMHURİYET MERKEZ BANKASI",
          sorgula: []
        },
        {
          content: "TÜRKİYE CUMHURİYETİ ZİRAAT BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRKİYE FİNANS KATILIM BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRKİYE GARANTİ BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRKİYE HALK BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRKİYE İŞ BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRKİYE KALKINMA BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRKİYE VAKIFLAR BANKASI T.A.O.",
          sorgula: []
        },
        {
          content: "YAPI VE KREDİ BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "ZİRAAT KATILIM BANKASI A.Ş",
          sorgula: []
        },
        {
          content: "DENİZBANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "ALBARAKA TÜRK KATILIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "ANADOLUBANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "VAKIF KATILIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "FİBABANKA ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "ALTERNATİFBANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "BURGAN BANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "AKTİF YATIRIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "ARAP TÜRK BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "CİTİBANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "BANK MELLAT MERKEZİ TAHRAN-İSTANBUL TÜRKİYE MERKEZ ŞUBESİ",
          sorgula: []
        },
        {
          content: "TÜRKİYE SINAİ KALKINMA BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "TÜRKİYE EMLAK KATILIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "GSD YATIRIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "ADABANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "BİRLEŞİK FON BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "BANK OF CHINA TURKEY ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "DEUTSCHE BANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "MUFG BANK TURKEY ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "RABOBANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "HABİB BANK LİMİTED MERKEZİ PAKİSTAN-İSTANBUL TÜRKİYE MERKEZ ŞB.",
          sorgula: []
        },
        {
          content: "INTESA SANPAOLO S.P.A. İTALYA İSTANBUL MERKEZ ŞUBESİ",
          sorgula: []
        },
        {
          content: "JPMORGAN CHASE BANK NATİONAL ASSOCİATİON MERKEZİ COLUMBUS OHİO İSTANBUL TÜRKİYE ŞUBESİ",
          sorgula: []
        },
        {
          content: "SOCIETE GENERALE(S.A)(PARİS)MERKEZİ FRANSA İSTANBUL TÜRKİYE MERKEZ ŞUBESİ",
          sorgula: []
        },
        {
          content: "DİLER YATIRIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "İSTANBUL TAKAS VE SAKLAMA BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "BANKPOZİTİF KREDİ VE KALKINMA BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "MERRILL LYNCH YATIRIM BANK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "PASHA YATIRIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "STANDARD CHARTERED YATIRIM BANKASI TÜRK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "MÜFLİS ASYA KATILIM BANKASI A.Ş.",
          sorgula: []
        },
        {
          content: "TÜRKİYE İHRACAT KREDİ BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "AKBANK TÜRK ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "GOLDEN GLOBAL YATIRIM BANKASI ANONİM ŞİRKETİ",
          sorgula: []
        },
        {
          content: "SERMAYE PİYASA KURULU (SPK)",
          sorgula: []
        },
        {
          content: "MERKEZİ KAYIT KURULUŞU (MKK)",
          sorgula: []
        },
        {
          content: "TAKASBANK",
          sorgula: []
        }

      ]
    },
    {
      code: "103davetiyesigonderilmesitalebi",
      title: "103 Davetiyesi Gönderilmesi Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        borcluAdSoyad: "",
        borcluMernisAdresi: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula: ["mernis"],
      html: this.getSablon("<p>Dosya borçlusunun aşağıda bulunan adresine 103 davetiyesi gönderilmesini talep ederim. </p><p> {borcluMernisAdresi} </p>")
    },
    {
      code: "dosyahesabi_yeni",
      title: "Dosya Hesabı (Yeni) Talebi",
      data: {
        icraDairesi: "",
        dosyaEsasNo: "",
        avAdSoyad: "",
        borcluAdSoyad: "",
        tarih: this.$helper.tarihStr(new Date())
      },
      sorgula: [],
      html: this.getSablon("<h3>İşlem Yapılacak Taraf Adı: {borcluAdSoyad} </h3><br>" +
          "<p>1-(1-Dosyada alacak kalemleri güncellemesi yapılmadığından dosya hesabı sekmesinde (Alacak Kalemleri ile İlişkilendirilmemiş Borç Tahsilatı Olduğundan Dosya Hesabı Yapılamıyor. Lütfen Borc Tahsilatlarını İlişkilendiriniz) Hatası vermektedir. Dosya hesabının doğru  yapılabilmesi için alacak kalemleri güncellemesinin yapılmasını talep ederim.</p>")
    },
  ];
}
